import { render, staticRenderFns } from "./TwoFactor.vue?vue&type=template&id=33b5291d&scoped=true&"
import script from "./TwoFactor.vue?vue&type=script&lang=js&"
export * from "./TwoFactor.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactor.vue?vue&type=style&index=0&id=33b5291d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b5291d",
  null
  
)

export default component.exports